export default ({ currentUser }) => currentUser.data?.authority === 'public';
